export const zeroPad = (str: string) => str.padStart(2, "0");
